import { isFaqSection } from '@bridebook/web/lib/wedding-website/utils/sections-typeguards';
import { useTranslation } from 'next-i18next';
import { useWeddingWebsiteData } from '../../data/data-context';
import { MotifOrnament, MotifSectionHookProps } from './motif-section-hooks';

export const MotifFaq = (hookProps: MotifSectionHookProps) => {
  const { t } = useTranslation('weddingWebsite');
  const { website } = useWeddingWebsiteData();
  const section = website.sections.find(isFaqSection);

  return (
    <section {...hookProps} className="bb-ww__section bb-ww__section--faq">
      <MotifOrnament />
      <h2 className="bb-ww__section-title">{t('previewMode.tile.faq.title2')}</h2>
      <div className="bb-ww__faq-list">
        {section?.data.map((qa) => (
          <div className="bb-ww__faq-item" key={qa.question}>
            <h3 className="bb-ww__faq-question">{qa.question}</h3>
            <p className="bb-ww__faq-answer">{qa.answer}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
